import { isEmpty } from "lodash";
import { socket } from "pages/socket/socket";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Alert,
  Card,
  Col,
  Container,
  ListGroup,
  ListGroupItem,
  Row,
} from "reactstrap";
import { createSelector } from "reselect";
import { controleAtendimento } from "slices/Empresa/thunk";
import withRouter from "../../Components/Common/withRouter";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";

const ControleAtendimento = () => {
  document.title = "Fila de atendimento :: Controle de atendimento";
  const [mensagem, setMensagem] = useState<any>(null);

  socket.on("empresas", (sockets: any) => {
    setMensagem(sockets);
  });

  const dispatch: any = useDispatch();
  const selectLayoutState = (state: any) => state.ControleAtendimento;
  const selectLayoutProperties = createSelector(selectLayoutState, (state) => ({
    controleAtendimentoList: state.controleAtendimentoList,
    isControleAtendimentoSuccess: state.isControleAtendimentoSuccess,
    maisEmpesa: state.maisEmpesa,
  }));

  const { controleAtendimentoList, isControleAtendimentoSuccess, maisEmpesa } =
    useSelector(selectLayoutProperties);

  const [ControleAtendimentoList, setControleAtendimentoList] = useState<any>(
    []
  );

  const [MaisEmpresa, setMaisEmpresa] = useState<any>(0);

  useEffect(() => {
    setMaisEmpresa(maisEmpesa);
  }, [maisEmpesa]);

  useEffect(() => {
    setControleAtendimentoList(controleAtendimentoList);
  }, [controleAtendimentoList]);

  useEffect(() => {
    if (!isEmpty(controleAtendimentoList))
      setControleAtendimentoList(controleAtendimentoList);
  }, [controleAtendimentoList]);

  useEffect(() => {
    if (!controleAtendimentoList.total) {
      dispatch(
        controleAtendimento({
          page: 0,
          limit: 5,
        })
      );
    }
  }, [dispatch, !controleAtendimentoList.total]);

  useEffect(() => {
    if (mensagem !== null) {
      setControleAtendimentoList(mensagem?.resultados);
      setMaisEmpresa(mensagem?.maisEmpesa);
    }
    setMensagem(null);
  }, [mensagem !== null]);

  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className="flex-grow-1" style={{ textAlign: "center" }}>
          <h2>Controle de atendimento</h2>
        </div>
        <div className="landing" style={{ paddingTop: 50 }}>
          {isControleAtendimentoSuccess &&
          ControleAtendimentoList.length > 0 ? (
            <Container>
              <Row className="justify-content-center">
                <Col className="col-lg-8">
                  <Card className="shadow-lg">
                    <ListGroup>
                      {ControleAtendimentoList.map((item: any, key: any) => (
                        <ListGroupItem
                          key={key}
                          style={{ fontSize: "xx-large", textAlign: "center" }}
                        >
                          <i className="ri-bill-line align-middle me-2"></i>
                          {item.nome}
                        </ListGroupItem>
                      ))}
                      {MaisEmpresa > 0 ? (
                        <ListGroupItem active style={{ textAlign: "center" }}>
                          + {MaisEmpresa} empresa(s)
                        </ListGroupItem>
                      ) : null}
                    </ListGroup>
                  </Card>
                </Col>
              </Row>
            </Container>
          ) : (
            <Alert color="danger" className="border-0 mb-xl-0">
              <i className="ri-error-warning-line label-icon"></i>
              <strong style={{ paddingLeft: "10px" }}>Sem registros</strong> !!!
            </Alert>
          )}
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default withRouter(ControleAtendimento);
